import { useNavigation, useRoute } from '@react-navigation/native';
import React, { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import { createEmptyMeeting, createEmptySpeaker } from '../../../utils/event.utils';
import useEventWidget from '../../../utils/useEventWidget';
import useFormList from '../../../utils/useFormList';
import BottomButton from '../../BottomButton';
import WrapBottomColor from '../../containers/WrapBottomColor';
import MeetingSection from '../../event/MeetingSection';
import SpeakerSection from '../../event/SpeakerSection';
import EventFormWidget from '../../EventWidget/EventFormWidget';
import DescriptionWidget from '../../TripEvents/DescriptionWidget';

const EventEditModal = () => {
  const route = useRoute();
  const navigation = useNavigation();
  const {
    event,
    user,
    speakers: prevSpeakers,
    meetings: prevMeetings,
    description: desc,
    returnScreen,
  } = route?.params || {};
  const [description, setDescription] = useState(desc);
  const [state, dispatch, openCalendar, , sideState] = useEventWidget(event);
  const {
    list: meetings,
    add: addMeeting,
    remove: removeMeeting,
    update: updateMeeting,
  } = useFormList(createEmptyMeeting, state?.hasMeeting, prevMeetings);
  const {
    list: speakers,
    add: addSpeaker,
    remove: removeSpeaker,
    update: updateSpeaker,
  } = useFormList(createEmptySpeaker, state?.hasSpeaker, prevSpeakers);

  useEffect(() => {
    setDescription(desc);
  }, [desc]);

  const onSubmit = () => {
    navigation.navigate(returnScreen, {
      event: state,
      speakers,
      meetings,
      user,
      description,
    });
  };

  return (
    <WrapBottomColor style={styles.container}>
      <ScrollView style={styles.innerContainer}>
        <EventFormWidget
          state={state}
          dispatch={dispatch}
          sideState={sideState}
          openCalendar={openCalendar}
        />
        {state?.hasDescription ? (
          <DescriptionWidget
            style={CommonStyles.mb5}
            description={description}
            onUpdate={(val) => setDescription(val)}
          />
        ) : null}
        {state?.hasMeeting ? (
          <MeetingSection
            list={meetings}
            onAdd={addMeeting}
            onRemove={removeMeeting}
            onUpdate={updateMeeting}
          />
        ) : null}
        {state?.hasSpeaker ? (
          <SpeakerSection
            list={speakers}
            onAdd={addSpeaker}
            onRemove={removeSpeaker}
            onUpdate={updateSpeaker}
          />
        ) : null}
      </ScrollView>
      <BottomButton
        stlye={CommonStyles.py4}
        labelStyle={{ ...CommonProperties.py2, ...CommonProperties.h2 }}
        label="Apply"
        full
        onPress={onSubmit}
      />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.accent,
  },
  innerContainer: {
    ...CommonProperties.p4,
  },
});

export default EventEditModal;
